import(/* webpackMode: "eager" */ "/vercel/path0/apps/lms/src/app/program-building/page.tsx");
